import { Address, Hex } from 'viem';

import { getActiveNetwork } from '@/lib/network/getActiveNetwork';
import { E_Network } from '@/ts/enums/E_Network';

export const C_KYC_MANAGER_ADDRESSES: Record<E_Network, Hex> = {
  [E_Network.SEPOLIA]: '0x970D57B1a3C5EE6736309ED6547Dc214E3425e90',
  [E_Network.BASE_SEPOLIA]: '0x970D57B1a3C5EE6736309ED6547Dc214E3425e90',
  [E_Network.BASE]: '0x6b240f6370AA41A35611886cA89524F2141B2cF7'
};

export const C_KYC_MANAGER_CONTRACT = C_KYC_MANAGER_ADDRESSES[
  getActiveNetwork()
] as Address;
